import React, { useEffect, useState } from "react";
import { observer } from "mobx-react";
import BloodStationsPage from "../../../components/bloodStationsPage/bloodStationsPage";
import DetailBloodStation, {
  IDetailBloodStation,
} from "../../../entities/detail_blood_station";
import DetailBloodStationPage from "../../../components/detailBloodStationPage";
import redirectTo from "../../../utils/redirectTo";
import { useStores } from "../../../hooks/mobx";
import { GetServerSideProps } from "next";
import {
  customGetServerSideProps,
  customGetServerSidePropsData,
  customGetServerSidePropsWithoutRequest,
} from "../../../utils/misc";
import SmartHeader from "../../../components/SmartHeader/SmartHeader";
import { cityIn } from "lvovich";

const isNumber = (n) => !isNaN(parseFloat(n)) && isFinite(n);

const BloodStations = observer(({ initialData, props }) => {
  const { recipientStore } = useStores();
  const [bloodStation, setBloodStation] = useState(null);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    setLoading(true);
    if (!props.isCity)
      recipientStore
        .getRecipientDonorNeedsBS(props.id)
        .then((response) => {
          setBloodStation({
            ...new DetailBloodStation(initialData as IDetailBloodStation),
            addressneed: response,
          });
        })
        .catch(() => redirectTo("/bloodstations/"))
        .finally(() => {
          setLoading(false);
        });
  }, [props.id]);

  if (props.isCity) {
    return (
      <SmartHeader
        title={`Центры крови в ${cityIn(props?.city?.title || "")}`}
        spinner={false}
        description={`Все станции переливания крови в ${cityIn(
          props?.city?.title || ""
        )}\nПрием донорской крови.`}
      >
        <BloodStationsPage initialSlug={props.id} isDefault={false} />
      </SmartHeader>
    );
  } else {
    return (
      <SmartHeader
        title={`${initialData?.title} | DonorSearch.org`}
        spinner={loading || !bloodStation}
        description={`Сдать кровь в ${cityIn(
          initialData?.city?.title
        )} - Расписание приёма доноров\n${initialData.address}`}
      >
        <DetailBloodStationPage id={props.id} bloodStation={bloodStation} />
      </SmartHeader>
    );
  }
});

export const getServerSideProps: GetServerSideProps = async (context) => {
  const id = context.query?.id;
  const isCity = !isNumber(id);
  if (isCity) {
    const data = await customGetServerSidePropsData(
      `/api/cities/${id}`,
      context
    );
    if (data?.notFound) {
      return {
        redirect: {
          permanent: true,
          destination: `/bloodstations/`,
        },
      };
    }
    if (data?.slug !== id)
      return await customGetServerSidePropsWithoutRequest({
        redirect: {
          permanent: true,
          destination: `/bloodstations/${data.slug}`,
        },
      });
    return await customGetServerSidePropsWithoutRequest({
      props: {
        isCity,
        id: data.id,
        city: data,
      },
    });
  }
  return await customGetServerSideProps(`/api/blood_stations/${id}/`, context, {
    isCity,
    id,
  });
};

export default BloodStations;
